import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { forwardRef, ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type TProps = TextFieldProps & {
  name: string;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
};

export const RHFTextField = forwardRef<HTMLDivElement, TProps>((props, ref) => {
  const { name, helperText, startAdornment, endAdornment, InputProps, ...others } = props;

  const { control } = useFormContext();

  const mergedInputProps = {
    ...InputProps,
    ...(startAdornment ? { startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment> } : {}),
    ...(endAdornment ? { endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment> } : {}),
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...others}
          {...field}
          ref={ref}
          value={field.value || ''}
          name={name}
          variant="outlined"
          error={!!error}
          helperText={error ? error.message : helperText}
          InputProps={mergedInputProps}
          fullWidth
        />
      )}
    />
  );
});
